import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MikrotikMapPageRoutingModule } from './mikrotik-map-routing.module';
import { MikrotikMapPageComponent } from './mikrotik-map/mikrotik-map.page';
import { FiltersModule } from 'libs/portal/src/modules/tools/filters/filters.module';
import { MaterialModule } from '@huge-monorepo/shared/modules';

@NgModule({
  imports: [CommonModule, FormsModule, MikrotikMapPageRoutingModule, FiltersModule, MaterialModule],
  declarations: [MikrotikMapPageComponent],
})
export class MikrotikMapPageModule {}
